// @ts-nocheck
/* eslint-disable */
import { addListener, makeEvent } from "~/lib/signals";
import { store } from "~/state/store";
import { CONFIG } from "~/config";
import GPXContent from '~/gpx/content';
import { exclusiveBoxesSetState } from "~/es6/exclusiveboxes";
import DistanceMeterContent from "~/distancemeter-content";
import UserMarksContent from "~/usermarks-content";
import Scene from "~/scene";
import SharePositionContent from "~/share-position/content";
import { default as SharePositionContent2 } from "~/share-position2/content";
import Detail from "~/detail";
import Canonical from "~/canonical";
import { setMapset } from "~/state/map/state";
import { MAP_OVERLAYS, DEFAULT_MAP_STATE } from "~/state/map/constants";
import { openPropositionDialog } from "~/util/premium";
import CouponActivationDialog from "~/ui/dialogs/coupon-activation-dialog";
import { ELoginState } from "~/state/user/interfaces";
import PaddleWrapper from "~/util/paddleWrapper";

(function() {
	/**
	 * @class Spravce historie: bere data od posluchacu a cpe je do history utilu
	 * @signal mapy-history-change signal o tom, ze se pravdepodobne zmenil stav mapy (byl zavolan history.save)
	 */
	class History {
		constructor() {
			this._seo = {
				"planovani-trasy": Mapy.getComponent("route"),
				"moje-mapy": Mapy.getComponent("mymaps"),
				"vlastni-body": Mapy.getComponent("userMarks"),
				"mereni-vzdalenosti": Mapy.getComponent("distanceMeter"),
				"profil": Mapy.getComponent("profile"),
				"sdileni-polohy": Mapy.getComponent("sharePosition"),
			};

			this._state = null;
			this._fromHistory = false;

			this._overlayItems = [DistanceMeterContent, UserMarksContent, Detail, Mapy.UserProfile, GPXContent, SharePositionContent, SharePositionContent2, Mapy.PathContent];
			this._prevSID = null;
			this._prevURL = "";
			this._jakHistory2 = new JAK.History2({
				processor: this
			});
			addListener(this, "history-change", "_historyChange", this._jakHistory2);
			this._rewriteMode = false;
		}

		getJakHistory2() {
			return this._jakHistory2;
		}

		/**
		 * je z historie?
		 * @return {Boolean}
		 */
		isFromHistory() {
			return this._fromHistory;
		}

		get state() {
			return this._state;
		}

		/**
		 * Ulozeni aktualniho stavu mapy do url.
		 * @param {[Boolean]} replace Prepsat aktualni url?
		 * @return {Boolean} Pri uspesnem ulozeni vraci true, jinak false pri vyjimce.
		 */
		save(replace) {
			if (CONFIG.inFrame) {
				return Promise.resolve();
			}

			/* ziskat data od relevantnich komponent */
			let data = Object.assign({},
				Mapy.getComponent("layout").getState(),
				Mapy.getComponent("reportDefect").getState(),
				Mapy.getComponent("dimcurator").getState()
			);

			let activeOverlay = this._getActiveOverlay();

			if (activeOverlay.length) {
				let state = activeOverlay[0].getState();
				if (Object.keys(state).length) { delete data.dim; }
				data = Object.assign(data, state);
			}
			else {
				for (let i=0;i<Mapy.active.length;i++) {
					data = Object.assign(data, Mapy.active[i].getState());
				}
			}

			if (Mapy.getComponent("gallery").isActive()) {
				Object.assign(data, Mapy.getComponent("gallery").getState());
			}

			if (Mapy.getComponent("photoDetail").isActive()) {
				Object.assign(data, Mapy.getComponent("photoDetail").getState());
			}

			// doplneni dat o to, co mame ve store
			const storeState = store.getState();

			// x, y, z, m3d, yaw, pitch, height, mapset, ovl
			Object.assign(data, {
				x: storeState.map.longitude.toFixed(7),
				y: storeState.map.latitude.toFixed(7),
				z: storeState.map.zoom,
				...storeState.map.provider === "m3d"
					? {
						m3d: 1,
						height: Math.round(storeState.map.height),
						yaw: Mapy.Util.formatNumber(storeState.map.yaw),
						pitch: Mapy.Util.formatNumber(storeState.map.pitch),
					}
					: {},
				mapset: storeState.map.mapset,
				...storeState.map.overlays.length ? { ovl: storeState.map.overlays.join(",") } : {},
			});

			if (this._rewriteMode) {
				replace = true;
			}

			if (this._prevSID) {
				this._prevSID.dontSave = true;
			}

			Mapy.getComponent("languageControl").setUrls(data);

			let obj = {};

			this._prevSID = obj;

			const toDelete = ["searchOrigin", "active"];

			for (const item of toDelete) {
				if (item in this._state) {
					delete this._state[item];
				}
			}

			this._state = data;

			return this._prevURL === this.serialize(data) ? Promise.resolve() :  Mapy.SIDCurator.getSIDFromData(data).then((newData) => {
				if (!obj.dontSave) {
					this._prevSID = null;
					this._prevURL = this.serialize(data);
					this._jakHistory2.save(newData, replace);
					makeEvent("mapy-history-change", this, {});
				}
			}, e => {
				this._prevURL = this.serialize(data);
				this._jakHistory2.save(data, replace);
				makeEvent("mapy-history-change", this, {});
			});
		}

		/**
		 * spusteni nacitani historie
		 */
		start() {
			try {
				let e = {
					data: {
						state: {
							...this._jakHistory2.get(),
							mapset: DEFAULT_MAP_STATE.mapset,
							...CONFIG.urlData ? this.parse(CONFIG.urlData) : {},
						}
					}
				}

				Mapy.getComponent("search").activate(); /* to je default, ochrana pred obnovenim z historie na detail */
				Mapy.getComponent("languageControl").setUrls(e.data.state);
				this._historyChange(e);
			} catch(ex) {
				console.log(ex);
			}
		}

		/**
		 * parsovani url stringu
		 * @param  {String} string url
		 * @return {Object} vysledny objekt s daty z url
		 */
		parse(string) {
			let result = {};
			string = string.split("#")[0];
			let part1 = string;
			let part2 = "";

			let index = string.indexOf("?");
			if (index != -1) {
				part1 = string.substring(0, index);
				part2 = string.substring(index+1);
			}

			const mapsetParts = part1.substring(1).split("/");
			const mapset = mapsetParts.length ? mapsetParts[mapsetParts.length - 1] : "";

			if (mapset) {
				result.mapset = mapset;
			}
			let parts = part2.split("&");

			parts.forEach((part) => {
				let keyvalue = part.split("=");

				if (keyvalue.length < 2 && !result.active) {  /* prave aktivni content */
					result.active = part;
					return;
				}

				try {
					let key = decodeURIComponent(keyvalue[0]);
					let value = decodeURIComponent(keyvalue.slice(1).join("=").replace(/\+/g, " "));

					if (value === "" && Object.keys(this._seo).indexOf(key) > -1) {
						result.active = key;
					}
					else {
						if (key in result) {
							let current = result[key];
							if (!(current instanceof Array)) {
								current = [current];
								result[key] = current;
							}
							current.push(value);
						} else {
							result[key] = value;
						}
					}

				}
				catch (e) {
				}
			});

			return result;
		}

		/**
		 * [serialize description]
		 * @param  {Object} data stav aplikace
		 * @return {String} url
		 */
		serialize(data, onlyComponentData) {
			const state = store.getState();
			let str = [];

			/* posledni aktivni je ten "hlavni" */
			let activeOverlay = this._getActiveOverlay();
			let active = activeOverlay.length ? activeOverlay[0] : Mapy.active[Mapy.active.length-1];

			if (activeOverlay.length && activeOverlay[0] instanceof Detail && state.detail.source == "closure") {
				active = Mapy.getComponent("route");
			}

			if (!onlyComponentData) {
				let seo = this._componentToSeo(active);
				if (seo) { str.push(encodeURIComponent(seo)); }
			}

			for (let p in data) {
				if (p == "mapset") { continue; }
				let value = [].concat(data[p]);
				for (let i = 0; i < value.length; i++) {
					str.push(encodeURIComponent(p) + "=" + encodeURIComponent(value[i]));
				}
			}

			let path = !onlyComponentData ? `/${CONFIG.defaultLang}/${data.mapset || ""}` : "";
			return `${path}${str.length ? `?${str.join("&")}` : ""}`;
		}

		/**
		 * Nastavit stav replace modu u historie.
		 * @param {Boolean} state Zapnuti/vypnuti prepisu historie.
		 */
		setRewriteMode(state) {
			this._rewriteMode = state;
		}

		/**
		 * Získaní stavu replace modu u historie.
		 * @param {Boolean}
		 */
		getRewriteMode() {
			return this._rewriteMode;
		}

		_componentToSeo(component) {
			for (let seo in this._seo) {
				if (this._seo[seo] == component) { return seo; }
			}
			return "";
		}

		/**
		 * nasatla zmena historie
		 * @param  {Object} e
		 */
		_historyChange(e) {
			let data = e.data.state;

			// #presmerovani starych url
			// presmerovani z planovani okruhu na planovani trasy
			if (data.active == "planovani-okruhu") {
				data.oldSEOUrl = 1;
				data.active = "planovani-trasy";
			}
			// presmerovani stareho batuzku a navstivenych na moje mapy
			if (data.active == "moje" || data.active == "visit") {
				data.active = "moje-mapy";
				data.cat = "mista-trasy";
			}
			// presmerovani fotomap do moje mapy
			if (data.active == "fotomapy") {
				data.active = "moje-mapy";
				data.cat = "fotografie";
				if ("aid" in data && data.aid != "") {
					data.mid = data.aid;
					delete data.aid;
				}
			}
			// presmerovani stop do moje mapy
			if (data.active == "stopy") {
				data.active = "moje-mapy";
				data.cat = "aktivity";
				if ("tid" in data && data.tid != "") {
					data.mid = data.tid;
					delete data.tid;
				}
			}
			// prepsani mereni a vlastnich bodu dle nove struktury url (obsolete??)
			if (data.active == "mereni-vlastni-bod") {
				if ("msw" in data) {
					data.active = data.msw;
				}
			}
			// presmerovani na nove detaily Moje mapy
			if (data.active == "moje-mapy" && "dt" in data && data.dt == "item") {
				data.dim = data.mid;
				delete data.dt;
				delete data.mid;
			}
			if (data.active == "moje-mapy" && "dt" in data && data.dt == "track") {
				delete data.dt;
				data.cat = "aktivity";
			}
			// oprava umisteni detailu z mych map a poi detailu v url > prednost dostane poi detail
			if ("dim" in data && "source" in data && "id" in data) {
				delete data.dim;
			}

			// nova galerie
			if ("source" in data && (["foto","ffoto"].indexOf(data.source) > -1 ) && "id" in data) {
				data.sourcep = data.source;
				data.idp = data.id;

				delete data.source;
				delete data.id;
				delete data.gallery;
			}

			if ("cat" in data && data.cat === "fotografie" && data.mid) {
				data.source = "author";
				data.id = data.mid;
				data.cat = "mista-trasy";

				delete data.mid;
			}

			// stare ophoto nahradime leteckou s novymi overlays
			if (data.base === "ophoto") {
				if (data.mapset === "dopravni") {
					data.ovl = MAP_OVERLAYS.TRAFFIC.toString();
				} else if (data.mapset === "fotografie") {
					data.ovl = [MAP_OVERLAYS.PHOTO, MAP_OVERLAYS.TURIST].toString();
				} else {
					data.ovl = MAP_OVERLAYS.TURIST.toString();
				}
				data.mapset = "letecka";
				delete data.base;
			}

			// starou fotografickou nahodime jako turistickou s fotkami jako overlayem
			if (data.mapset === "fotografie") {
				data.mapset = "turisticka";
				data.ovl = MAP_OVERLAYS.PHOTO.toString();
			}

			// starou katastralni nahodime jako leteckou s katastralnim overlayem
			if (data.mapset === "katastralni") {
				data.mapset = "letecka";
				data.ovl = MAP_OVERLAYS.CADASTRAL.toString();
			}

			// ptaci pohled zmenime na pohled na leteckou mapu
			if ("or" in data && "oc" in data) {
				data.mapset = "letecka";
				delete data.or;
				delete data.oc;
			}

			// #presmerovani starych url - konec

			// pokud se chci koukat na vlastni verejny profil, mam smulu a jdu do MM
			const state = store.getState();
			const { user } = state.user;

			if (user.state === "green" && user.userPublicId === data.up) {
				data.active = "moje-mapy";

				switch (data.upc) {
					case "reviews":
						data.cat = "reviews";
						break;
					default:
						data.cat = "dashboard";
						break;
				}

				delete data.up;
				delete data.upc;
			}

			// pro analytiku si posleme jeste, ze jde o akci vyvolanou zmenou URL
			data.searchOrigin = "browser_history";

			this._fromHistory = true;

			let active = this._seo[data.active] || Mapy.getComponent("search");
			let allComponents = [Mapy].concat(Mapy.active).concat(active);
			[
				"userProfile",
				"detail",
				"pano",
				"gallery",
				"activerequest",
				"timeboard",
				"webcam",
				"reportDefect",
				"legend",
				"mobilepromo",
				"landingPagePromo",
				"tweaksList",
				"layout",
				"sharePosition",
			].forEach(name => {
				allComponents.push(Mapy.getComponent(name));
			});

			allComponents.push(Mapy.getComponent("photoDetail"));

			/* pokud je nejaka komponenta v poli dvakrat postarame se o jeji odstraneni.
			 * slo predevsim o detail, ktery se setoval dvakrat a delalo to problemy loaderu */
			let components = allComponents.filter(function(com, pos) {
				return allComponents.indexOf(com) == pos;
			});

			let activeOverlay = this._overlayItems.filter(function(i) {
				return (active instanceof i);
			});

			let postPhase = activeOverlay.length || "dim" in data || data.active === "planovani-trasy";

			if (!postPhase && !active.isActive()) {
				active.activate();
			}

			let setComponentState = (data) => {
				for (let i = 0; i < components.length; i++) {
					let item = components[i];

					if (!item) continue;

					this._setState(item, data);
				}

				// exclusive boxes
				exclusiveBoxesSetState(data);

				if (postPhase) {
					if ("dim" in data) { // pokud mame dim v url, nacitame pomoci dimcuratoru
						Mapy.getComponent("dimcurator").setState({ dim: data.dim }, data).loadData().then(() => {
							this._fromHistory = false;
						}, e => {
							this._fromHistory = false;
						});
					} else {
						active.activate();
						this._fromHistory = false;
					}
				} else {
					this._fromHistory = false;
				}
			}

			if ("sid" in data) { // pokud mame sid v url, nacitame pomoci sidcuratoru
				Mapy.ProviderSID.getData(data.sid).then(d => {
					let sidData = this.parse(d.url);
					if (typeof sidData.mapset === "string" && !sidData.mapset) {
						delete sidData.mapset;
					}
					this._state = {
						...data,
						...sidData,
					};
					setComponentState(this._state);
				}, e => {
					this._state = data;
					setComponentState(this._state);
				});
			} else {
				this._state = data;
				setComponentState(this._state);
			}

			if ("om" in data && Scene) {
				Scene.addPreviewMap(data.om);
			}

			// pokud mame stranku s uzivatelskym profilem a pridruzene pod stranky, tak nechceme indexovat
			if (data.up && !document.head.querySelector("meta[name=robots]")) {
				const metaRobots = document.createElement("meta");

				metaRobots.setAttribute("name", "robots");
				metaRobots.setAttribute("content", "noindex");
				document.head.appendChild(metaRobots);

				Canonical.remove();
			}

			// otevreme premium propozici, kdyz najdeme prislusny atribut v url
			if ("proposition" in data) {
				const user = store.getState().user.user;

				if (!user.premium) {
					openPropositionDialog("url");
				} else {
					Mapy.getComponent("premiumStatus").activate();
				}

				PaddleWrapper.initialize();
			}

			// pokud jdeme na URL s id kuponu, tak rovnou zacneme proces prijmuti premia
			if ("premium-coupon-id" in data) {
				const user = store.getState().user.user;

				// pokud uzivatel neni prihlaseny, tak ho presmerujeme na login
				if (user.state !== ELoginState.Green) {
					const url = new URL(`https://login.szn.${CONFIG.TLDCZ}`);
					const returnUrl = new URL((window as Window & typeof globalThis).location.href);

					Array.from(returnUrl.searchParams.keys()).forEach(key => returnUrl.searchParams.delete(key));
					returnUrl.searchParams.set("premium-coupon-id", data["premium-coupon-id"]);
					url.searchParams.set("return_url", returnUrl.toString());
					url.searchParams.set("serviceId", "mapy");

					(window as Window & typeof globalThis).location.href = url.toString();

					return;
				}

				let couponDialog: CouponActivationDialog = null;
				const dispose = () => {
					couponDialog?.destroy();
					couponDialog = null;
				};

				couponDialog = new CouponActivationDialog({
					onClose: dispose,
					onBack: dispose,
					onFinished: async data => {
						dispose();
						await Mapy.getComponent("login").relogin();

						Mapy.getComponent("logger").log("premiumPurchase_success", {
							purchaseOrigin: data?.subscriptions?.length ? data.subscriptions[0].subscriptionOrigin : "coupon",
						});

						Mapy.getComponent("premiumStatus").activate();
					},
					couponId: data["premium-coupon-id"],
				});
			}

			const mapset = data.mapset || state.map.mapset;
			let overlays = (data.ovl as string)?.split(",").map(overlay => parseInt(overlay)).filter(number => !isNaN(number)) || state.map.overlays;

			// fix bezkarskych tras v URL, ktera neni ale zimni mapa
			if (mapset !== "zimni" && overlays.indexOf(MAP_OVERLAYS.SKI) > -1) {
				overlays = [];
			}

			store.dispatch(setMapset({
				mapset,
				overlays,
			}));
		}

		/**
		 * Volani set state metody nad component + pokud vraci promise a obsahuje metodu historyAfterState,
		 * zavolame i ji.
		 *
		 * @param {Object} item
		 * @param {Object} data
		 */
		_setState(item, data) {
			let output = item.setState(data);

			if (output && typeof output["then"] === "function" && "historyAfterState" in item) {
				output.then(function() {
					item.historyAfterState(data);
				}, () => {});
			}
		};

		/**
		 * navrati pole s aktivnima overlayema
		 * @return {Array} pole s overlayema
		 */
		_getActiveOverlay() {
			let output = [];

			for (let i = 0, max = Mapy.active.length; i < max; i++) {
				let active = Mapy.active[i];

				for (let j = 0, max2 = this._overlayItems.length; j < max2; j++) {
					let overlayItem = this._overlayItems[j];

					if (active instanceof overlayItem) {
						output.push(active);
					}
				}
			}

			return output;
		}

	}

	Mapy.History = History;
}());
